import React from 'react';
import TodoListListing from '../TodoListListing';

const TodoTabListing = ({ tabId, listRefreshKey, onCountChange }) => (
    <TodoListListing
        key={`list-${tabId}-${listRefreshKey}`}
        onCountChange={onCountChange}
        activeTabId={tabId}
    />
);

export default TodoTabListing;
